import BusinessBuildingIcon from './BusinessBuildingIcon'

export default BusinessBuildingIcon
